import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconOnaChevronRight: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g transform="translate(2,2)">
                        <path
                            d="M4.66663 3.33334L7.33329 6L4.66663 8.6667"
                            stroke="currentColor"
                            strokeLinecap="square"
                        />
                    </g>
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g transform="translate(4,4)">
                        <path
                            d="M4.33329 2.66667L7.6666 6L4.33329 9.3333"
                            stroke="currentColor"
                            strokeLinecap="square"
                        />
                    </g>
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g transform="translate(6,6)">
                        <path d="M4 2L8 6L4 10" stroke="currentColor" strokeLinecap="square" />
                    </g>
                </svg>
            );
    }
};
